/**
 * @generated by @puffin-tooling/esm-build — DO NOT EDIT BY HAND.
 *
 * Source of truth: this package's CJS entry (`lib/index.js`).
 * Regenerate with `pnpm esm:build`; CI fails if this file is stale
 * (see the esmBuildFreshness cross-app contract).
 *
 * This RE-EXPORTS the CJS surface rather than duplicating it. Hand-editing
 * it reintroduces PLN-CALENDAR-RULE-001 D4: two copies of one module,
 * drifting silently.
 */

import cjs from '../index.js';

export default cjs;

export const {
  IDEMPOTENCY_KEY_HEADER,
  IN_DOUBT_TRANSPORT_CODES,
  NOT_SENT_TRANSPORT_CODES,
  RETRYABLE_REFUSAL_CODES,
  RETRYABLE_STATUSES,
  RETRY_REASONS,
  SAFE_METHODS,
  SANCTIONED_REPLAY_SAFE,
  SESSION_UNREACHABLE_CODE,
  isReplaySafeRequest,
  mayAutoRetry,
  mintIdempotencyKey,
} = cjs;
